module.exports = __webpack_public_path__ + "static/media/PTH_map.313c70a3.jpg";